import React from 'react';
import './sales-parameters.scss';
import { useSelector } from 'hooks/redux';
import { BlockchainTransactionInfo } from 'components';

export default function BuyParameters() {
  const buyingCfa: any = useSelector((state) =>
    state.operationsSign.data.buyingCfa?.tokenName !== undefined
      ? state.operationsSign.data.buyingCfa
      : state.operationsSign.data.purchase
  );

  return (
    <div>
      <p className="p p_bold p_color_grey mb_24">Параметры покупки</p>
      {buyingCfa.blockchainTransactionId && (
        <div className="mb_24">
          <p className="p p_font-size_12 p_color_light-grey mb_4">
            {buyingCfa.status === 'APPLIED'
              ? 'ID транзакции (зачисление)'
              : ' ID транзакции (резервирование)'}
          </p>
          <BlockchainTransactionInfo hash={buyingCfa.blockchainTransactionId} />
        </div>
      )}
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Наименование токена
        </p>
        <p className="p p_color_light-blue mb_12">{buyingCfa?.tokenName}</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Количество продаваемых токенов
        </p>
        <p className="p p_color_grey mb_12">{buyingCfa?.tokenCount}</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Цена одного токена
        </p>
        <p className="p p_color_grey mb_12">{buyingCfa?.tokenPrice} ₽</p>
      </div>
      <div>
        <p className="p p_font-size_12 p_color_light-grey">
          Общая цена продажи
        </p>
        <p className="p p_color_grey">{buyingCfa?.paymentAmount} ₽</p>
      </div>
    </div>
  );
}
